import React from "react";

type Props = {
  password: string;
};

// パスワードの強度を計算する関数
const calculateStrength = (password: string): string => {
  if (password.length === 0) return "st0";
  if (password.length < 8) return "st1";

  let varietyCount = 0;
  if (/[a-z]/.test(password)) varietyCount++; // 小文字
  if (/[A-Z]/.test(password)) varietyCount++; // 大文字
  if (/\d/.test(password)) varietyCount++; // 数字
  if (/[^a-zA-Z0-9]/.test(password)) varietyCount++; // 記号

  if (varietyCount <= 1) return "st1";
  if (varietyCount === 2) return "st2";
  return "st3";
}

export const StrengthBar = ({ password }: Props) => {
  const level = calculateStrength(password);
  
  return (
    <dl id="strengthBar" className={level}><dt><span></span></dt><dd></dd></dl>
  );
};